import React from "react";
import _ from "lodash";
import { createStyles, Grid, makeStyles, Typography } from "@material-ui/core";
import "jspdf-autotable";

import { CustomTheme } from "../../../../types/customTheme";
import CardCommon from "../../../../components/card/CardCommon";

export interface CustomerNodeProps {}

const useStyles = makeStyles((theme: CustomTheme) => 
  createStyles({
    headerText: {
      fontWeight: "bold",
      color: theme.palette.text.primary,
    },
    titleColumn: {
      display: "flex",
      justifyContent: "start",
      paddingLeft: "12px",
      alignItems: "center",
    },
    statusColumn: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    actionColumn: {
      display: "flex",
      justifyContent: "flex-end",
      paddingRight: "12px",
      alignItems: "center",
    },
  })
);

const BannerHeader: React.FunctionComponent<CustomerNodeProps> = ({}) => {
  const classes = useStyles();

  return (
    <>
      <CardCommon backgroundColor={"table_header_background"}>
        <Grid container style={{ height: "32px", placeItems: "center" }}>
          {/* Title Column - matches BannerInfoNode xs=3 */}
          <Grid
            item
            xs={3}
            className={classes.titleColumn}
          >
            <Typography className={classes.headerText}>Title</Typography>
          </Grid>
          
          {/* SubTitle Column - matches BannerInfoNode xs=3 */}
          <Grid item xs={3}>
            <Typography align="left" className={classes.headerText}>
              Subtitle
            </Typography>
          </Grid>
          
          {/* Status Column - matches BannerInfoNode xs=2 */}
          <Grid item xs={2} className={classes.statusColumn}>
            <Typography className={classes.headerText}>Status</Typography>
          </Grid>
          
          {/* Description Column - matches BannerInfoNode xs=2 */}
          <Grid item xs={2}>
            <Typography align="left" className={classes.headerText}>
              Description
            </Typography>
          </Grid>
          
          {/* Actions Column - matches BannerInfoNode xs=2 */}
          <Grid
            item
            xs={2}
            className={classes.actionColumn}
          >
            <Typography className={classes.headerText}>Actions</Typography>
          </Grid>
        </Grid>
      </CardCommon>
    </>
  );
};

export default BannerHeader;